class VanillaSmoothScroll {
  constructor(triggerSelector = 'a[href*="#"]', speed = "smooth") {
    this.triggers = document.querySelectorAll(triggerSelector);
    this.speed = speed;

    this._init();
    this._scrollOnLoad();
  }

  _init() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        const href = trigger.getAttribute("href");

        if (!href) return;

        if (href === "#") {
          e.preventDefault();
          this._scrollToTop();
          return;
        }

        const url = new URL(href, window.location.href);
        const hash = url.hash;

        if (!hash) return;

        const isSamePage =
          url.pathname === window.location.pathname &&
          url.origin === window.location.origin;

        if (!isSamePage) return;

        const target = document.querySelector(hash);

        if (!target) return;

        e.preventDefault();
        this._scrollToTarget(target);
        history.pushState(null, "", hash);
      });
    });
  }

  _scrollOnLoad() {
    if (!window.location.hash) return;

    window.addEventListener("load", () => {
      const target = document.querySelector(window.location.hash);

      if (!target) return;

      setTimeout(() => {
        this._scrollToTarget(target);
      }, 50);
    });
  }

  _getHeaderOffset() {
    const rootFontSize = parseFloat(
      window.getComputedStyle(document.documentElement).fontSize,
    );

    return window.innerWidth >= 1280 ? 12.8 * rootFontSize : 6 * rootFontSize;
  }

  _scrollToTarget(target) {
    const headerOffset = this._getHeaderOffset();

    const targetPosition =
      window.pageYOffset + target.getBoundingClientRect().top - headerOffset;

    window.scrollTo({
      top: targetPosition,
      behavior: this.speed,
    });
  }

  _scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: this.speed,
    });
  }
}

export default VanillaSmoothScroll;
